import MapPin from "./MapPin";
export default MapPin;
